/* ============
 * UnderlyingAssetType Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    assets: [],
    currentAssetIdInDB: null,
  },
  actions,
  getters,
  mutations
};
